import { render, staticRenderFns } from "./CircleNovoiceIcon.vue?vue&type=template&id=8e129114&"
import script from "./CircleNovoiceIcon.vue?vue&type=script&lang=js&"
export * from "./CircleNovoiceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports